import * as React from 'react'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { adminService } from '../../../../core/services'
import { InputText } from '../../../atoms'
import AdminLayoutEdit from '../_layouts/edit'
import * as interfaces from '../../../../static/interfaces'

declare var window: interfaces.IWindow

interface IProps {
  category: IJsonResponse
}

const FIELDS = {
  id: 'id',
  name: 'name',
  name_ja: 'name_ja',
  position: 'position',
}

const title = I18n.t('admin.edit', {
  model: I18n.t('category', { scope: 'activerecord.models' }),
})

const AdminCategoryEdit: React.FC<IProps> = props => {
  const { data: category } = adminService.getDataFromJson(props.category)
  const handleSubmit = React.useCallback(async (initialValues, values) => {
    const { updatedCategory, flush } = await adminService.updateCategory(values)
    window.flashMessages.addMessage({ text: flush.message, type: flush.type })
    location.href = '/admin/categories'
  }, [])

  return (
    <AdminLayoutEdit
      model="category"
      title={title}
      fields={FIELDS}
      indexLink="/admin/categories"
      formItems={
        <>
          <InputText
            readonly={true}
            name="id"
            defaultValue={category.id}
            label={I18n.t('generic.id')}
          />
          <InputText
            required={true}
            name="name"
            defaultValue={category.name}
            label={I18n.t('generic.name')}
          />
          <InputText
            required={false}
            name="name_ja"
            defaultValue={category.name_ja}
            label={I18n.t('generic.name_ja')}
          />
          <InputText
            required={true}
            name="position"
            defaultValue={category.position}
            label={I18n.t('generic.position')}
          />
        </>
      }
      handleSubmit={handleSubmit}
    />
  )
}

export default AdminCategoryEdit
